import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import useMyRequests from '@/hooks/requests/useMyRequests'

const formatRequestedAt = (createdAt: string) => {
  const date = new Date(createdAt)
  if (Number.isNaN(date.getTime())) {
    return '-'
  }
  return date.toLocaleString()
}

export default function RequestHistoryTable() {
  const { data: requests, isLoading } = useMyRequests()

  return (
    <section className="w-full max-w-4xl mx-auto mt-8">
      <h2 className="text-lg font-semibold mb-4">Request History</h2>
      <div className="border rounded-md">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-center">Course Code</TableHead>
              <TableHead className="text-center">Section</TableHead>
              <TableHead className="text-center">Semester</TableHead>
              <TableHead className="text-center">Status</TableHead>
              <TableHead className="text-center">Requested At</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={5}>
                  <div className="space-y-2 py-2">
                    <Skeleton className="h-6 w-full" />
                    <Skeleton className="h-6 w-full" />
                    <Skeleton className="h-6 w-full" />
                  </div>
                </TableCell>
              </TableRow>
            )}

            {!isLoading && (!requests || requests.length === 0) && (
              <TableRow>
                <TableCell colSpan={5} className="text-center h-24 text-muted-foreground">
                  You have not submitted any course requests yet.
                </TableCell>
              </TableRow>
            )}

            {!isLoading &&
              requests?.map((courseRequest) => (
                <TableRow key={courseRequest.requestId} className="hover:bg-muted/50 transition-colors">
                  <TableCell className="text-center">{courseRequest.courseCode}</TableCell>
                  <TableCell className="text-center">{courseRequest.section}</TableCell>
                  <TableCell className="text-center">{courseRequest.semester}</TableCell>
                  <TableCell className="text-center">
                    <Badge
                      variant={
                        courseRequest.status === 'Approved'
                          ? 'default'
                          : courseRequest.status === 'Rejected'
                            ? 'destructive'
                            : 'secondary'
                      }
                    >
                      {courseRequest.status}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-center">{formatRequestedAt(courseRequest.createdAt)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    </section>
  )
}
